import { render } from "./dzjy.vue?vue&type=template&id=0170e303&scoped=true&ts=true"
import script from "./dzjy.vue?vue&type=script&lang=ts"
export * from "./dzjy.vue?vue&type=script&lang=ts"

import "./dzjy.vue?vue&type=style&index=0&id=0170e303&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0170e303"]])

export default __exports__